//! Dwv needs the URLs to be in the format of https://<path>
export const standardizeHttpsUrl = (url) => {
  if (!url) return url;
  if (url.startsWith('https://')) return url;
  const doubleSlashIndex = url.indexOf('//');
  if (doubleSlashIndex !== -1) {
    // Extract everything after '//' and prepend https://
    return `https://${url.substring(doubleSlashIndex + 2)}`;
  }
  return `https://${url}`;
};
